import { graphql } from '~publish/graphql'

/**
 * A Note's reactions on their own, so an optimistic reaction can override
 * this one field and leave the rest of the Note to the server.
 */
export const CollaborationNoteReactionsFields = graphql(/* GraphQL */ `
  fragment CollaborationNoteReactionsFields on CollaborationNote @_unmask {
    id
    reactions {
      emoji
      count
      hasReacted
      accounts {
        id
        name
        email
      }
    }
  }
`)
